import styled from '../../../../../../../styles/styledComponents/themeComponents';

export const BannerWidgetScrollLayoutStyle = styled.div`
  .widget-banner-section {
    margin-bottom: 20px;

    .amondz-img {
      width: 100%;
      border-radius: 2px;
    }

    .title,
    .contents {
      padding: 0 15px;
    }

    .title {
      margin-top: 8px;
      font-size: 14px;
      font-weight: bold;
      letter-spacing: -0.5px;
      color: black;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }

    .contents {
      margin-top: 1px;
      font-size: 12px;
      letter-spacing: -0.1px;
      color: #9b9b9b;
      line-height: 1.5;
    }
  }
`;
